/**
 * Signin Firebase
 */
import { formatMoney } from "accounting-js";
import { useState } from "react";
import { AiOutlineFilePdf } from "react-icons/ai";
import InvoiceStyle from "./InvoiceStyle";
import { useGeneratePdf } from "../../../hooks/useGeneratePdf";
import ColorGrowingSpinner from "../../../components/Spinners/ColorGrowingSpinner";
import NotFreeModal from "../../../components/modelpopup/NotFreeModal";

export default function MnthVPt({
  s,
  setS,
  exp,
  setExp,
  a,
  setA,
  capex,
  setCapex,
  companyName,
  companyNumber,
  year,
  month,
  taxRate,
  setMonth,
  customerName,
  customerNumber,
  setCompanyName,
  setCompanyNumber,
  setCustomerName,
  setCustomerNumber,
  setYear,
  lang,
  DEAR,
  TAXNUMBER,
  TAXINVOICENUMBER,
  DATE,
  PAYUNTIL,
  TOTAL,
  NOTE,
  SIGNATURE,
  ORIGINAL,
  name,
  taxNum,
  address,
  cityAddress,
  logo,
  phone,
  coData,
  revenues,
  expenses,
  fixedExpenses,
  setFixedExpenses,
  list,
  setRevenues,
  revenuesExempt,
  setRevenuesExempt,
  setExpenses,
  amounts,
  discount,
  total,
  information,
  totalAfDiscount,
  perTax,
  dueDate,
  totalAfTax,
  exemptionAmount,
  headerDetails,
  showModal2,
  setShowModal2,
  invoiceNumber,
  dateInvoice,
}) {
  const { printRef, generatePdf, printing } = useGeneratePdf();

  // States
  const [resultColor, setRcolor] = useState("bbc4cc");
  const bool = true;
  const [show, setShow] = useState(false);

  const [tax, setTax] = useState(""); // نسبة الضريبة

  const [b, setB] = useState(0); // صفقات ملزمة = المبلغ
  const [c, setC] = useState(0); // ض.ق.م على الصفقات
  const [dd, setD] = useState(0); // ( ض . ق . م ) مدخلات أصول ثابتة ( תשומות )
  const [ee, setE] = useState(0); // ( ض . ق . م ) مدخلات عادية ( תשומות )
  const [result, setResult] = useState(0); //المبلغ للدفع / للارجاع
  const [showDiv, setShowDiv] = useState(false);
  // const printRef = React.useRef();

  // const [printing, setPrinting] = useState(false);
  // const { user } = useAuthContext()

  // Form initial state
  const INITIAL_STATE = {
    month: month,
    year: year,
    tax: "18",
    s: s,
    a: a,
    capex: capex,
    exp: exp,
    b: " ",
    c: " ",
    dd: " ",
    ee: " ",
    result: " ",
  };

  const [values, setValues] = useState(INITIAL_STATE);
  //MODAL
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);
  // Handle Change Function
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prevState) => ({ ...prevState, [name]: value }));
    // console.log(values)
  };
  function clearForm() {
    document.getElementById("calcForm").reset();
  }
  //  احتساب جديد
  const newCalc = () => {
    window.location.reload();
  };

  // Current Date
  const d = new Date().toLocaleString() + "";
  let current = d.split(",");
  const today = current[0];
  const todaySplitArr = today.split("/");
  const todayFrm =
    " " +
    todaySplitArr[1] +
    " / " +
    todaySplitArr[0] +
    " / " +
    todaySplitArr[2];

  //=================  Form Submit Handler====================
  function Calculate(e) {
    e.preventDefault();
    setShowDiv(true);
    // setMonth(values.month);
    // setYear(values.year);
    setTax(values.tax);
    setA(values.a);
    // values calculations
    const amount = s * 1;
    if (amount !== "" && values.tax !== "") {
      if (bool) {
        var amountNew = (s * 1) / (values.tax / 100 + 1);
        const amountTaxx = parseFloat(s) - parseFloat(amountNew);
        var cValue = amountTaxx.toFixed(2);
        setC(Math.round(amountTaxx));
        const amountTotall = amountNew.toFixed(2);
        setB(Math.round(amountTotall));

        // D and E values
        var dValue = (exp * 1) / (values.tax / 100 + 1);
        var eValue = (capex * 1) / (values.tax / 100 + 1);
        var tvalue = values.tax / 100;
        var ddd = dValue * tvalue;
        var eee = eValue * tvalue;

        setD(Math.round(ddd));
        setE(Math.round(eee));
        // Total result value
        var calcResult = cValue - (eee + ddd);

        setResult(Math.round(calcResult));
        if (calcResult < 0) {
          setRcolor("red");
        } else {
          setRcolor("green");
        }
      } else {
        const amountTax2 = (s * values.tax) / 100;
        setC(amountTax2.toFixed(2));
        const amountTotal2 = parseFloat(s) + parseFloat(amountTax2);
        setB(amountTotal2.toFixed(2));
      }
    } else {
      setC("0.00");
      setB("0.00");
    }
  }
  let taxRateN = parseFloat(taxRate) / 100;
  //=================  Form Submit Handler====================

  const handleDownloadPdf = async () => {
    console.log("printing later");
  };
  return (
    <div className="row">
      <div className={printing ? "loading-opacity" : "  card "}>
        <div className=" card-header ">
          <h2 className=" text-center mt-2 text-primary">مجاميع </h2>
        </div>
        <div className=" card-body eOfService ">
          <form onSubmit={Calculate} id="calcForm">
            <div className="row"></div>
            <div className="row  border-div success p-4">
              <h2 className="card-title text-center">المبيعات </h2>
              <div className="col-sm-2"></div>

              <div className="col-sm-4">
                <div className="form-group">
                  <label>
                    {" "}
                    المبيعات / <span> شامل </span>{" "}
                  </label>
                  <input
                    className="form-control "
                    defaultValue=""
                    type="number"
                    name="s"
                    value={s}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>
                    {" "}
                    المبيعات / <span> معفى </span>{" "}
                  </label>
                  <input
                    className="form-control"
                    defaultValue=""
                    type="number"
                    name="a"
                    value={a}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <div className="row border-div danger p-4 ">
              <h2 className="card-title text-center">المصاريف </h2>
              <div className="col-sm-2"></div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>
                    المصاريف العادية / <span> شامل </span>{" "}
                  </label>
                  <input
                    className="form-control "
                    defaultValue=""
                    type="number"
                    name="exp"
                    value={exp}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>
                    المصاريف / أصول / <span> ثابتة </span>{" "}
                  </label>
                  <input
                    className="form-control "
                    defaultValue=""
                    type="number"
                    name="capex"
                    value={capex}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className=" form-group">
                <div className="submit-section">
                  <button className="btn btn-primary submit-btn col-md-4">
                    احسب{" "}
                  </button>
                </div>
              </div>
              {/* <div className="col-sm-4">
                      <div className="submit-section">
                        <button className="btn btn-primary submit-btn" onClick={clearForm}>تقرير جديد    </button>
                      </div>
                    </div> */}
              {/* <div className='col-sm-2'></div> */}
            </div>
          </form>
        </div>
      </div>

      {/* ====================== Report Start ========================================= */}
      {showDiv && (
        <>
          {show ? (
            <div className={printing ? "loading-opacity row " : "row"}>
              <InvoiceStyle
                lang={lang}
                DEAR={DEAR}
                TAXNUMBER={TAXNUMBER}
                TAXINVOICENUMBER={TAXINVOICENUMBER}
                DATE={DATE}
                PAYUNTIL={PAYUNTIL}
                TOTAL={TOTAL}
                NOTE={NOTE}
                SIGNATURE={SIGNATURE}
                ORIGINAL={ORIGINAL}
                name={name}
                // printRef={printRef}
                taxNum={taxNum}
                address={address}
                cityAddress={cityAddress}
                phone={phone}
                companyName={companyName}
                companyNumber={companyNumber}
                customerName={customerName}
                customerNumber={customerNumber}
                year={year}
                month={month}
                logo={logo}
                coData={coData}
                revenues={revenues}
                setRevenues={setRevenues}
                revenuesExempt={revenuesExempt}
                setRevenuesExempt={setRevenuesExempt}
                expenses={expenses}
                setExpenses={setExpenses}
                fixedExpenses={fixedExpenses}
                setFixedExpenses={setFixedExpenses}
                list={list}
                amounts={amounts}
                tax={tax}
                discount={discount}
                total={total}
                information={information}
                totalAfDiscount={totalAfDiscount}
                perTax={perTax}
                dueDate={dueDate}
                totalAfTax={totalAfTax}
                exemptionAmount={exemptionAmount}
                headerDetails={headerDetails}
                handleDownloadPdf={handleDownloadPdf}
                // handleSubmit={handleSubmit}

                show={show}
                setShow={setShow}
                showModal={showModal2}
                setShowModal={setShowModal2}
                invoiceNumber={invoiceNumber}
                dateInvoice={dateInvoice}
              />
            </div>
          ) : (
            <div className={printing ? "print-style loading-opacity" : ""}>
              <div className=" card">
                <div className="card-header">
                  <h4 className=" card-title mb-0 text-center text-primary p-3">
                    <span className="float-end ">
                      <button
                        className="btn "
                        onClick={() => generatePdf(`" Fintrack_كشف دوري"`)}
                      >
                        <AiOutlineFilePdf size={30} className="text-primary" />
                      </button>
                    </span>
                    <span> تقرير كشف دوري </span>
                  </h4>
                </div>
                <div
                  className={printing ? " card-body print-style" : "card-body "}
                  ref={printRef}
                >
                  <form className="vat-form">
                    <div className={printing ? "row" : "d-none"}>
                      <h2 className="card-title text-center text-primary mt-4">
                        تقرير كشف دوري{" "}
                        <span className="text-primary float-start ">
                          {" "}
                          {todayFrm}{" "}
                        </span>{" "}
                      </h2>
                    </div>
                    <div className=" row ">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">
                            {" "}
                            الفترة / سنة{" "}
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            defaultValue=""
                            placeholder={printing ? " " : "سنة"}
                            value={year ? year : ""}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">
                            الفترة / شهر{" "}
                          </label>
                          <input
                            className="form-control "
                            defaultValue=""
                            type="text"
                            placeholder={printing ? " " : "شهر"}
                            value={month ? month : ""}
                            readOnly
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label"> اسم الشركة </label>
                          <input
                            className="form-control"
                            type="text"
                            defaultValue=""
                            value={companyName ? companyName : " "}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label"> رقم الشركة </label>
                          <input
                            className="form-control "
                            defaultValue=""
                            type="text"
                            value={companyNumber ? companyNumber : " "}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">
                            {" "}
                            نسبة القيمة المضافة{" "}
                          </label>
                          <input
                            className="form-control "
                            defaultValue=""
                            type="text"
                            value={" 18 % "}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">
                            {" "}
                            نسبة سلفيات ضريبة الدخل{" "}
                          </label>
                          <input
                            className="form-control "
                            defaultValue=""
                            type="text"
                            value={taxRate ? taxRate + " % " : ""}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row border-div success">
                      <div>
                        <h3 className=" text-primary">( ض . ق . م )</h3>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">
                            (ض . ق . م ) على الصفقات{" "}
                          </label>
                          <input
                            className="form-control "
                            readOnly
                            type="text"
                            value={formatMoney(c ? c : 0, {
                              symbol: "₪",
                              format: " %v %s",
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">
                            {" "}
                            صفقات ملزمة{" "}
                          </label>
                          <input
                            className="form-control "
                            readOnly
                            type="text"
                            value={formatMoney(b ? b : 0, {
                              symbol: "₪",
                              format: " %v %s",
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">
                            {" "}
                            صفقات معفية{" "}
                          </label>
                          <input
                            className="form-control "
                            defaultValue=""
                            readOnly
                            type="text"
                            value={
                              formatMoney(a ? a : 0, {
                                symbol: "₪",
                                format: " %v %s",
                              }) + " "
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row border-div danger flex-column">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">
                            ( ض . ق . م ) مدخلات أصول ثابتة ( תשומות ){" "}
                          </label>
                          <input
                            className="form-control "
                            readOnly
                            defaultValue=""
                            type="text"
                            value={formatMoney(ee ? ee : 0, {
                              symbol: "₪",
                              format: " %v %s",
                            })}
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">
                            ( ض . ق . م ) مدخلات عادية ( תשומות ){" "}
                          </label>
                          <input
                            className="form-control "
                            readOnly
                            type="text"
                            value={formatMoney(dd ? dd : 0, {
                              symbol: "₪",
                              format: " %v %s",
                            })}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row border-div success justify-content-start">
                      <div className="col-sm-4 ">
                        <div className="form-group">
                          <label className="col-form-label">
                            {" "}
                            المبلغ للدفع /{" "}
                            <span className={printing ? "" : "text-danger"}>
                              للارجاع{" "}
                            </span>
                          </label>
                          {!printing && (
                            <input
                              className="form-control "
                              style={{
                                color: resultColor,
                                fontWeight: "bold",
                              }}
                              readOnly
                              type="text"
                              value={formatMoney(result ? result : 0, {
                                symbol: "₪",
                                format: " %v %s",
                              })}
                            />
                          )}
                          {printing && (
                            <input
                              className="form-control "
                              readOnly
                              type="text"
                              value={formatMoney(result ? result : 0, {
                                symbol: "₪",
                                format: " %v %s",
                              })}
                            />
                          )}
                        </div>
                      </div>
                    </div>{" "}
                    <div className="row ">
                      <div>
                        <hr />
                        <h3 className=" text-primary mb-2">
                          {" "}
                          سلفيات ضريبة الدخل{" "}
                        </h3>
                      </div>

                      <div className="col-sm-12 col-md-3 ">
                        <div className="form-group">
                          <label className="col-form-label">
                            {" "}
                            مجموع الدخل{" "}
                          </label>

                          <input
                            className="form-control "
                            readOnly
                            type="text"
                            value={formatMoney(b + a ? b + a : 0, {
                              symbol: "₪",
                              format: " %v %s",
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-1 m-auto p-4 mt-3 ">
                        <h3
                          className={
                            printing
                              ? "text-center  text-primary-black"
                              : "text-center"
                          }
                        >
                          {" "}
                          X{" "}
                        </h3>
                      </div>

                      <div className="col-sm-12 col-md-3 ">
                        <div className="form-group">
                          <label className="col-form-label">
                            {" "}
                            نسبة سلفيات ضريبة الدخل %{" "}
                          </label>

                          <input
                            className="form-control "
                            // style={{ color: resultColor, fontWeight: "bold" }}
                            readOnly
                            type="text"
                            value={taxRate ? taxRate : 0 + " % "}
                            // value={formatMoney(result ? result : 0, { symbol: "₪", format: " %v %s" })}
                          />
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-1  m-auto p-4 mt-2">
                        <div className="form-group">
                          <h1
                            className={
                              printing
                                ? "text-center  text-primary-black"
                                : "text-center"
                            }
                          >
                            {" "}
                            ={" "}
                          </h1>
                        </div>
                      </div>

                      <div className="col-sm-12 col-md-3 ">
                        <div className="form-group">
                          <label className="col-form-label">
                            {" "}
                            سلفيات ضريبة الدخل{" "}
                          </label>

                          <input
                            className="form-control "
                            readOnly
                            type="text"
                            value={formatMoney(
                              (b + a) * taxRateN ? (b + a) * taxRateN : 0,
                              { symbol: "₪", format: " %v %s" }
                            )}
                          />
                        </div>
                      </div>
                    </div>{" "}
                    <hr />
                    {!printing && (
                      <div className=" row text-center mt-4 mb-4 pt-4 ">
                        <button
                          className="btn submit-btn btn-primary col-md-4 m-auto"
                          onClick={(e) => {
                            e.preventDefault(); // stops the form submission
                            generatePdf("تقرير كشف دوري- Fintrack");
                          }}
                        >
                          <AiOutlineFilePdf size={30} className=" " /> طباعة
                          الكشف PDF
                        </button>
                        <button
                          className="btn btn-primary submit-btn  col-md-4 m-auto"
                          onClick={() => {
                            setShow(!show);
                          }}
                        >
                          معاينة القيود
                        </button>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      {/*============================Report End==========================  */}

      <div
        className={
          printing
            ? "loading-opacity row   card flex-column "
            : "row   card flex-column "
        }
      >
        {/* <div className="card-body col-md-12  text-center">
          <a
            href="https://secapp.taxes.gov.il/EMHANDOCH/STARTPAGEINTERNET.ASPX"
            target="_blank"
            className="btn btn-primary btn-block btn-download  col-md-3 ms-4"
          >
            <span className="button-links"> تصريح </span>
          </a>

          <a
            href="https://secapp.taxes.gov.il/EMHANPAYMENT/HAZANATPIRTEYTASHLUM.ASPX"
            target="_blank"
            className="btn btn-primary btn-block btn-download  col-md-4 ms-4"
          >
            <span className="button-links"> دفع </span>
          </a>

          <a
            href="https://secapp.taxes.gov.il/EmDvhmfrt/wUploadFileHeshboniotSim.aspx"
            target="_blank"
            className="btn btn-primary btn-block btn-download   col-md-3 "
          >
            <span className="button-links"> فحص ملف ( PCN )</span>
          </a>
        </div> */}
        <div className="card-body col-md-12  text-center">
          <a
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#notAvailable"
            target="_blank"
            className="btn btn-primary btn-block btn-download  col-md-3 ms-4"
          >
            <span className="button-links"> تسجيل القيود لنظام MassBill </span>
          </a>

          <a
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#notAvailable"
            target="_blank"
            className="btn btn-primary btn-block btn-download  col-md-4 ms-4"
          >
            <span className="button-links">تصدير القيود لأنظمة خارجية </span>
          </a>

          <a
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#notAvailable"
            target="_blank"
            className="btn btn-primary btn-block btn-download   col-md-3 "
          >
            <span className="button-links">تنزيل إكسل</span>
          </a>
        </div>
      </div>
      {printing && (
        <ColorGrowingSpinner
          intensityLevels={[0.4, 0.6, 0.8, 0.9, 1]} // Opacity levels for #ff9b44
        />
      )}
      <NotFreeModal
        modalId="notAvailable"
        title="تسجيل القيود لنظام MassBill "
        content="الخدمة غير متاحة   في النسخة المجانية  ! "
      />
      <NotFreeModal
        modalId="notAvailable2"
        title="تصدير القيود لأنظمة خارجية "
        content="الخدمة غير متاحة   في النسخة المجانية  ! "
      />
      <NotFreeModal
        modalId="notAvailable3"
        title="تنزيل إكسل "
        content="الخدمة غير متاحة   في النسخة المجانية  ! "
      />
    </div>
  );
}
